import { ConnectorsCard } from "./ConnectorsCard";
import { PairingCodeCard } from "./PairingCodeCard";

export const ConnectClinicPanel = () => (
  <div className="flex flex-col gap-6 font-body">
    <ConnectorsCard />
    <PairingCodeCard />
  </div>
);
